import { Box, CircularProgress } from '@mui/material';
import { LogosHeader } from '../LogosHeader';

/**
 * Loading screen shown during app initialization and Service Worker updates
 * Displays logos with branding text and spinner for unified loading interface
 */
export function AppInitializer() {
  return (
    <Box
      sx={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 3
      }}
    >
      <LogosHeader />
      <CircularProgress size={60} />
    </Box>
  );
}
